import React, { useState } from 'react';

import { makeStyles, Grid } from '@material-ui/core';
import { MeInteresa } from '@portal/arq-portal-me-interesa';
import { Eventos } from '@portal/arq-portal-eventos';

import { Marquesina } from '@portal/arq-portal-marquesinas';
import { ResultadoFinanciero } from '@portal/arq-portal-resultados-financieros';
import { Footer } from '@portal/arq-portal-footer';
import { EnlacePortalAntiguo } from '@portal/arq-portal-enlaceportalantiguo'
const MiEspacio = React.lazy(() => import('./HomeMiEspacio'));

const useStyles = makeStyles((theme: any) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    content: {
        padding: "0px 28px 20px",
        backgroundColor: "#f0f0f0",
        minHeight: 'calc(100vh - 124px)',
        [theme.breakpoints.down('sm')]: {
            padding: "0px 12px 20px",
            overflowX: "hidden"
        },
    }
    ,
    headContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        '@media screen and (max-width: 1250px)': {
            display: 'block',
        },
    },
    containerMensaje: {
        flex: 'auto',
        marginTop: '4px',
        '&>div>div': {
            paddingRight: '15px',
        },
        '@media screen and (max-width: 1250px)': {
            paddingRight: '0px',
        },
    },
    containerFinancieros: {
        '&>div': {
            paddingLeft: '20px',
        }
    },
}),
);

export default function Home(props: any) {
    const classes = useStyles();
    const [marquesinaId, setMarquesinaId] = useState('');

    const verificarMarquesina = () => {
        return localStorage.getItem('MarquesinaId') !== marquesinaId;
    };

    const onMarquesinaCargada = (marquesinaId: string) => {
        setMarquesinaId(marquesinaId);
    };

    return (
        <React.Fragment>
            <div className={classes.content}>
                <div className={classes.headContainer}>
                    <div className={classes.containerMensaje}>
                        <EnlacePortalAntiguo style={{ padding: '5px 0px' }} />
                    </div>
                    <div className={classes.containerFinancieros}>
                        <ResultadoFinanciero />
                    </div>
                </div>
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        <Grid item md={9} zeroMinWidth>
                            <MeInteresa style={{ marginLeft: "-12px", marginRight: "-12px" }}></MeInteresa>
                        </Grid>
                        <Grid item xs={12} md={3} zeroMinWidth>
                            <Eventos />
                        </Grid>
                    </Grid>
                </div>
                <MiEspacio />
                {verificarMarquesina() &&
                    <Marquesina disposable={true} onClose={props.manejarCierreMarquesina} onMarquesinaLoaded={onMarquesinaCargada} />
                }
            </div>
            <Footer />
        </React.Fragment>
    )
}